/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { useCreateArticleLocalization } from '../api/articles';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams } from 'react-router-dom';
import useToastNotification from './useToastNotification';

export const useAddArticleLocalization = (setEditorState, EditorState) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { mutate, isSuccess, isLoading, isError } = useCreateArticleLocalization();
  const navigate = useNavigate();

  const schema = yup
    .object()
    .shape({
      title: yup.string().required(t('titleRequired')),
      shortDescription: yup.string().required(t('shortDescriptionRequired')),
      text: yup.string().required(t('textRequired')),
      language: yup.string().required(t('languageRequired')),
    })
    .required();

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    register,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      title: '',
      shortDescription: '',
      text: '',
      language: '',
    },
    resolver: yupResolver(schema),
    reValidateMode: 'onChange',
  });

  useToastNotification({
    isShow: isSuccess,
    loading: isLoading,
    messageKey: 'successAddedLocalizationsArticle',
    variant: 'success',
  });

  useToastNotification({
    isShow: isError,
    loading: isLoading,
    messageKey: 'errorAddingLocalizationsArticle',
    variant: 'error',
  });

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append('title', data.title);
    formData.append('shortDescription', data.shortDescription);
    formData.append('language', data.language);
    formData.append('text', data.text);
    formData.append('article', id);

    mutate({ data: formData });
    reset();
    setEditorState(EditorState.createEmpty());
    navigate(-1);
  };

  return {
    handleSubmit,
    control,
    onSubmit,
    isLoading,
    errors,
    register,
  };
};
